import { createContext, useMemo, useState } from 'react';

export const wlpContext = createContext({});

const WlpProvider = ({ children }) => {
  const [isWLP, setIsWLP] = useState(false);
  const [wlpName, setWlpName] = useState('');
  const [logo, setLogo] = useState(null);
  const [navbarFontColour, setNavbarFontColour] = useState('#fff');
  const [showMainPageText, setShowMainPageText] = useState(false);
  const [showWebinars, setShowWebinars] = useState(false);
  const [muiTheme, setMuiTheme] = useState(null);

  const wlpData = useMemo(
    () => ({
      isWLP,
      setIsWLP,
      wlpName,
      setWlpName,
      logo,
      setLogo,
      navbarFontColour,
      setNavbarFontColour,
      showMainPageText,
      setShowMainPageText,
      showWebinars,
      setShowWebinars,
      muiTheme,
      setMuiTheme,
    }),
    [isWLP, wlpName, logo, navbarFontColour, showMainPageText, showWebinars, muiTheme, setMuiTheme]
  );

  return <wlpContext.Provider value={wlpData}>{children}</wlpContext.Provider>;
};

export default WlpProvider;
